import { isDebug } from "@/constants";
import type { CustomUrlMap, Manifest } from "@/types";
import { useGLTF, useTexture } from "@react-three/drei";
import { preloadBuffer } from "./playSound";

export const preloadAssets = (
  mediaUrl: string,
  manifests: Manifest[],
  customUrlMap?: CustomUrlMap,
) => {
  Object.values(manifests).forEach((manifest) => {
    Object.entries(manifest?.resources || {}).forEach(
      ([resourceType, resources]) => {
        Object.values(resources).forEach((resource) => {
          if (typeof resource === "object" || !resource) return;

          const asset = customUrlMap
            ? customUrlMap[resource as string]
            : `${mediaUrl}/dice/bundles/${manifest.slug}/${resource}`;

          if (resourceType === "models") {
            useGLTF.preload(asset);
          } else if (resourceType === "textures") {
            useTexture.preload(asset);
          } else if (resourceType === "sounds") {
            preloadBuffer(asset);
          } else {
            fetch(asset);
          }

          if (isDebug) {
            console.log(`[DiceCanvas] Preloaded resource: ${asset}`);
          }
        });
      },
    );
  });

  if (isDebug) {
    console.log(
      `[DiceCanvas] Preloading common noise map texture: ${mediaUrl}/dice/bundles/basic/images/noise-map.png`,
    );
  }

  useTexture.preload(`${mediaUrl}/dice/bundles/basic/images/noise-map.png`);

  if (isDebug) {
    console.log(
      `[DiceCanvas] Preloading common environment texture: ${mediaUrl}/dice/images/common/environment.jpg`,
    );
  }

  useTexture.preload(`${mediaUrl}/dice/images/common/environment.jpg`);
  // Preload fallback collision sounds
  Array.from({ length: 3 }).forEach((_, index) => {
    preloadBuffer(`${mediaUrl}/dice/sounds/collision-${index + 1}.wav`);
  });
};
